import { z } from 'zod';

import type { Address } from '@/models/Address.ts';
import type { Authority } from '@/models/Authority.ts';
import type { EntityNote } from '@/models/EntityNote.ts';
import type { Phone } from '@/models/Phone.ts';
import type { Scheme } from '@/models/Scheme.ts';

import { ContactSchema } from './Contact';

export const ServiceUserStatusSchema = z.enum([
  'ACTIVE',
  'INACTIVE',
  'DRAFT',
  'READY',
]);
export type ServiceUserStatus = z.infer<typeof ServiceUserStatusSchema>;

export const ServiceUserSalesTypeSchema = z.enum([
  'GROUP_LIVING',
  'INDEPENDENT',
]);

export const ServiceUserSchema = z.object({
  id: z.string(),
  tag: z.array(z.record(z.string(), z.string())),
  avatar: z.string().nullable(),
  status: ServiceUserStatusSchema,
  salesType: ServiceUserSalesTypeSchema,
  personInfoId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  fullName: z.string(),
  dateOfBirth: z.string().nullable().optional(),
  gender: z.string(),
  email: z.string(),
  address: z.custom<Address>(),
  nino: z.string().nullable().optional(),
  phoneNumbers: z.array(z.custom<Phone>()),
  createDate: z.string(),
  lastUpdateDate: z.string(),
  connectionName: z.any().nullable(),
  connectionsCount: z.number().int().nonnegative(),
  entityNotes: z.array(z.custom<EntityNote>()).nullable(),
  contacts: z.array(ContactSchema).optional(),
  schemeInfo: z.custom<Scheme>().nullable().optional(),
  authorityInfo: z.custom<Authority>().nullable().optional(),
  integrationData: z
    .object({
      PANNOVATION: z
        .object({
          external_id: z.string(),
        })
        .nullish(),
    })
    .nullish(),
});

export type ServiceUser = z.infer<typeof ServiceUserSchema>;
